module.exports = __webpack_public_path__ + "a889b5d58955699627b8268c04824f93.patt";